import { render, staticRenderFns } from "./TemplateStep.vue?vue&type=template&id=52853fdc&scoped=true"
import script from "./TemplateStep.vue?vue&type=script&lang=ts"
export * from "./TemplateStep.vue?vue&type=script&lang=ts"
import style0 from "./TemplateStep.vue?vue&type=style&index=0&id=52853fdc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52853fdc",
  null
  
)

export default component.exports